import { TGuid } from '@core/helpers';
import { BroadcastEvent } from '@core/services';

export class ChatEnterEvent extends BroadcastEvent {
  constructor(public chatId: TGuid) {
    super();
  }
}
